export const completionNotificationsQueryKeys = {
  all: () => ['/completion-notifications'] as const,
  byEvent: (completionEventId: number) =>
    [...completionNotificationsQueryKeys.all(), 'by-event', completionEventId] as const,
};
